import { CoreAPI, createCommonOfferMethods } from '@hero/sdk-core';

/**
 * Carrier-facing Offer surface. Carriers and brokers can be both target
 * (inbox / accept / counter / decline) and proposedBuyer (rebroadcast to
 * their own private network).
 */
export function createOffersAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonOfferMethods(coreAPI),
  };
}
